
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"12"}}),_c('path',{attrs:{"fill":"#F2F4F8","d":"M13.426 10.629H20v2.782h-6.574V20h-2.893v-6.589H4V10.63h6.533V4h2.893z"}})])])
          )
        }
      }
    